import React from 'react';
import { createRoot } from 'react-dom/client';
import PortalJobListing from './App';

const elementContainer = document.querySelector<HTMLElement>('#portal-job-listing-root');

if (elementContainer) {
  const root = createRoot(elementContainer);
  root.render(<PortalJobListing />);
}
